export const rules = {
    email: [
        { required: true, message: 'Please input your email' },
        { type: 'email', message: 'The input is not valid email' },
    ],
};